import { Box, Card, CardContent, CardHeader, Divider, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

type CardMetricProps = {
  title: string
  subTitle: string
  metric?: number
}

const useStyles = makeStyles((theme) => ({
  pageHeader: {
    fontSize: theme.typography.pxToRem(32),
  },
  cardTypography: {
    fontSize: theme.typography.pxToRem(16),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  count: {
    fontSize: theme.typography.pxToRem(24),
    textAlign: 'center',
  },
}))

const CardMetric = ({ title, subTitle, metric }: CardMetricProps) => {
  const { cardTypography, count, container } = useStyles()
  return (
    <Box aria-label={`Metrics for ${title}`}>
      <Card
        className={container}
        elevation={0}
        style={{ height: '100%' }}
      >
        <CardHeader
          style={{ flexGrow: 1 }}
          title={title}
          titleTypographyProps={{ className: cardTypography, variant: 'body1', color: 'textPrimary', component: 'h3' }}
          subheader={subTitle}
          subheaderTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
        />
        <Divider light />
        <CardContent>
          <Box
            height="100%"
            width="100%"
          >
            <Typography
              className={count}
              color="textSecondary"
            >
              {metric === undefined ? <span>&mdash;</span> : `${metric}`}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}
export default CardMetric
